import Plyr from "plyr/src/js/plyr.polyfilled";

import "plyr/src/sass/plyr.scss";
import "./styles.scss";

export default Plyr;
